export default __webpack_public_path__ + "images/dcf2a1eb19c199895b51c5b8f94fdca6.jpg";